import { computed, inject, Injectable, signal } from '@angular/core';
import { Category } from 'src/app/models/category.model';
import { CacheLoaderService } from './cache-loader.service';
import { AppStateService } from '../app/app-state.service';
import { learningCategories } from '../data/learning/learning-categories';
// import { UserAccessService } from '../app/user-access.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  // userAccessService = inject(UserAccessService);
  foundersCategoryIds: number[] = [];
  categories = signal<Category[]>([]);
  selectedCategory = signal<Category | null>(null);
  constructor(
    private cacheLoader: CacheLoaderService<Category>,
    private learningModeService: AppStateService
  ) {
    this.loadCategories();
   }

  setCategories(categories: Category[]) {
    // console.log('setting categories,', categories);
    this.categories.set(categories);
    this.setSelectedCategoryById(this.categories()[0].CategoryID);
  }


  loadCategories(): void {
    if(this.learningModeService.learningMode()) {
      this.setCategories(learningCategories);
    } else {
      this.cacheLoader.loadData('categories', (categories) => {
        // console.log('Categories loaded:', categories);
        this.setCategories(categories);
      }, 'categoriesCacheKey');
    }
  }

  setSelectedCategoryById(categoryId: number) {
    // console.log('setting selected category by id', categoryId);
    const category = this.categories().find(c => c.CategoryID === categoryId) || null;
    this.selectedCategory.set(category);
  }
}
